import './App.css';
import AllRoutes from './Routes';
import { useEffect } from 'react';

// Хелпер, чтобы удобно менять title
export function usePageTitle(title) {
  useEffect(() => {
    if (!title) return;
    const prev = document.title;
    document.title = title;
    return () => { document.title = prev; };
  }, [title]);
}

function App() {
  // Поставим дефолтный заголовок приложения
  usePageTitle('Attendance Panel');

  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
